/**
 * @generated SignedSource<<ac1198d0f65a94ce7a49e24b38ff6c4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleContentStatus_teamSchedule$data = {
  readonly events: ReadonlyArray<{
    readonly __typename: "RoutineOccasion";
    readonly id: string;
    readonly status?: RoutineOccasionStatus;
    readonly taskExecution?: {
      readonly routineOccasion: {
        readonly __typename: "RoutineOccasion";
        readonly status: RoutineOccasionStatus;
        readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion">;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion">;
  }>;
  readonly " $fragmentType": "WidgetTeamScheduleContentStatus_teamSchedule";
};
export type WidgetTeamScheduleContentStatus_teamSchedule$key = {
  readonly " $data"?: WidgetTeamScheduleContentStatus_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentStatus_teamSchedule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleContentStatus_teamSchedule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeInlineRoutines",
          "value": true
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "type": "RoutineOccasion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskExecutionCheck",
              "kind": "LinkedField",
              "name": "taskExecution",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineOccasion",
                  "kind": "LinkedField",
                  "name": "routineOccasion",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v0/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TeamScheduleInlineRoutineOccasion",
          "abstractKey": null
        }
      ],
      "storageKey": "events(includeInlineRoutines:true)"
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};
})();

(node as any).hash = "49ee0c3a60312919227a4a1d6d530c8c";

export default node;
